import React, { PureComponent } from 'react';
import DropdownAlert, { DropdownAlertType } from 'react-native-dropdownalert';

const AlertType = DropdownAlertType || { Error: 'error', Success: 'success', Info: 'info', Warn: 'warn' };

let alert = null;
let isShowing = false;
let latestAlert = null;

export default class DropAlert extends PureComponent {
  static show(data) {
    if (isShowing) {
      latestAlert = data;
      return;
    }

    DropAlert.display(data);
  }

  static display(data) {
    if (!alert) return;

    isShowing = true;
    alert(data).finally(() => {
      isShowing = false;

      if (latestAlert) {
        const nextAlert = latestAlert;
        latestAlert = null;
        DropAlert.display(nextAlert);
      }
    });
  }

  static notify(type, title, message, interval = 2000) {
    DropAlert.show({ message, title, type, interval });
  }

  static error(title, message, interval) {
    DropAlert.notify(AlertType.Error, title, message, interval);
  }

  static success(title, message, interval) {
    DropAlert.notify(AlertType.Success, title, message, interval);
  }

  static info(title, message, interval) {
    DropAlert.notify(AlertType.Info, title, message, interval);
  }

  static warn(title, message, interval) {
    DropAlert.notify(AlertType.Warn, title, message, interval);
  }

  componentWillUnmount() {
    isShowing = false;
    latestAlert = null;
    alert = null;
  }

  render() {
    return (
      <DropdownAlert
        updateStatusBar={false}
        inactiveStatusBarBackgroundColor={'rgba(255,255,255,0)'}
        successImageSrc={null}
        infoImageSrc={null}
        warnImageSrc={null}
        errorImageSrc={null}
        translucent={true}
        inactiveStatusBarStyle={'dark-content'}
        alert={(func) => (alert = func)}
      />
    );
  }
}
